//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//

(function () {
    'use strict';
    angular.module('container.components')
        .directive('srsngSoftwareInfo', srsngSoftwareInfo);

    function srsngSoftwareInfo($rootScope, Localization, userSettingsService, Event) {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/components/software-info/software-info.html',
            scope: {
                showSoftwareInfoModal: '='
             },
            controller: controller
        };

        function controller($scope, SOFTWARE_VERSION) {

            $scope.close = close;
            $scope.softwareInfo = SOFTWARE_VERSION;

            $rootScope.$on(Event.USER_LOGGED_OUT, () => {
                $scope.showSoftwareInfoModal = false;
            });
            
            function close() {
                // $rootScope.$emit('userProfile:cancel');

                //todo: save that user closed it manually in usersettings

                $scope.showSoftwareInfoModal = false;
            }

            
        }

    }

})();

